import { NgModule } from '@angular/core';
import { CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../shared/security/auth.guard';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PTLSharedModule } from '../shared/shared.module';
import { PendingTransactionsComponent } from './pending-transactions/pending-transactions.component';
import { TransactionsService } from './transactions.service';
import { TransactionsErrorComponent } from './transactions-error/transactions-error.component';
import { TransactionIndividualHistoryComponent } from './transaction-history-individual/transaction-history-individual.component';
import { TransactionHistoryBrokerComponent } from './transaction-history-broker/transaction-history-broker.component';
import { PipeModule } from '../shared/pipes/pipe.module';
import { MatSortModule, MatTableModule, MatTabsModule } from '@angular/material';
import { TransactionHistoryIndividualSearchComponent } from './transaction-history-individual-search/transaction-history-individual-search.component';
import { TransactionHistoryBrokerSearchComponent } from './transaction-history-broker-search/transaction-history-broker-search.component';
import { MyDatePickerModule } from 'mydatepicker';


const routes: Routes = [
  { path: 'pendingTransactions', component: PendingTransactionsComponent, canActivate: [AuthGuard]},
  { path: 'transactions-error', component: TransactionsErrorComponent, canActivate: [AuthGuard]},
  { path: 'transactionIndividualHistory', component: TransactionIndividualHistoryComponent, canActivate: [AuthGuard]},
  { path: 'transactionIndividualHistorySearch', component: TransactionHistoryIndividualSearchComponent, canActivate: [AuthGuard]},
  { path: 'transactionHistoryBroker', component: TransactionHistoryBrokerComponent, canActivate: [AuthGuard]},
  { path: 'transactionHistoryBrokerSearch', component: TransactionHistoryBrokerSearchComponent, canActivate: [AuthGuard]}
  
];
@NgModule({
  imports: [MatSortModule,
    MatTableModule,
    MatTabsModule,
    ReactiveFormsModule,
    CommonModule,RouterModule.forChild(routes), FormsModule, MyDatePickerModule, PipeModule.forRoot(),PTLSharedModule
  ],
  
  declarations: [PendingTransactionsComponent, TransactionsErrorComponent, TransactionIndividualHistoryComponent, TransactionHistoryBrokerComponent, TransactionHistoryIndividualSearchComponent, TransactionHistoryBrokerSearchComponent],
  providers :[TransactionsService]
})
export class TransactionsModule { }



// WEBPACK FOOTER //
// ./src/app/transactions/transactions.module.ts